import { render } from "./PayPassword.vue?vue&type=template&id=1ac59e40&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=1ac59e40&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=1ac59e40&lang=scss"

import exportComponent from "D:\\Git\\思途茶业\\思途茶业pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac59e40"]])

export default __exports__